<template>
    <div class="input-group d-flex filter__options__search">
        <vue-select name="q"
            v-model="search"
            v-on:change="onChange"
            :options="localKeywords"
            :inputId="key"
            class="form-control filter__options__search__input p-2 m-auto"
            placeholder="Search products"
            taggable
            ></vue-select>
        <div class="input-group-append filter__options__search__btn">
            <button v-on:click="submit" class="btn btn-primary" type="button">
                <img src="/img/site/icons/icon-search.svg" alt="">
            </button>
        </div>
    </div>
</template>
<script>
import VueSelect from 'vue-select';
import UtilsMixin from '../UtilsMixin';

export default {
    data() {
        return {
            key: 'searchKeywords' + Date.now(),
            localKeywords: [],
            localValue: null,
        }
    },

    props: ['value', 'config'],

    mixins: [UtilsMixin],

    created() {
        this._searchApi = _.debounce(this.searchApi, 300);
    },

    mounted() {
        $(`#${this.key}`).on('input', (e) => {
            // this.localValue = newVal;
            // this.$emit('input', newVal);
            this._searchApi({
                search_query: e.target.value,
            });
        })
    },

    components: {
        VueSelect,
    },

    watch: {
        value(newVal) {
            this.localValue = newVal;
        },
    },

    computed: {
        search: {
            get() {
                return this.localValue;
            },

            set(newVal) {
                this.localValue = newVal;
                this.$emit('input', newVal);
                // this._searchApi({
                    // search_query: newVal,
                // });
            },
        },

        rootPath() {
            return _.get(this.config, 'rootPath', '/our-products');
        },

        submitOnChange() {
            return _.get(this.config, 'submitOnChange', true);
        },
    },

    methods: {
        searchApi(query) {
            return this.api.getData('/../search', query)
                .then((res) => {
                    this.localKeywords = _.chain(res).get('keywords', []).uniq().value();
                    this.$forceUpdate();
                })
        },

        submit() {
            const query = new URLSearchParams(window.location.search);
            query.set('q', this.localValue);
            return window.location.href = `${this.rootPath}?${query.toString()}`;
        },

        onChange(value) {
            const query = new URLSearchParams(window.location.search);
            if (value !== query.get('q')) {
                query.set('q', value || '');

                if (value && this.submitOnChange) {
                    return window.location.href = `${this.rootPath}?${query.toString()}`;
                }
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/site/js/components/form/SearchInputComponent.vue